import { Barcos } from './../models/barcos';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';



@Injectable({
  providedIn: 'root'
})
export class BarcoService {

  constructor(
    public http: HttpClient
  ) { }


  agregarbarco( barco: Barcos ) {
    let url = URL_SERVICIOS + '/barco';
    return this.http.post ( url , barco)
    .map (( resp: any ) => {
    //   console.log (resp);
    });

  }

  listado( idempresa: string ) {
    let url = URL_SERVICIOS + '/barco/' + idempresa;
    return this.http.get ( url)
    .map ( (resp: any) => resp.barcos);


  }

 


  actualizar(datosparaguardar: Barcos) {
       
   
    let url = URL_SERVICIOS + '/barco/actualiza/' + datosparaguardar._id;
      return this.http.put ( url, datosparaguardar )
  }


  borrar(idborrar: string){
    let url = URL_SERVICIOS + '/barco/'+ idborrar;
      return this.http.delete ( url );

  }

  agregar (datosparaguardar: Barcos) {
    
      let url = URL_SERVICIOS + '/barco/agrega';
      return this.http.post ( url, datosparaguardar )

    
  }


  vercorreoBarco( idbarco: string ) {
    let url = URL_SERVICIOS + '/barco/buscabarco/' + idbarco;
    return this.http.get <Barcos> ( url)
    .map ( (resp: any) => resp.barcos);


  }



}



